import type { TimerState } from "./types";

export function timerElapsed(timer: TimerState, now: number): number {
  return timer.startedAt === null ? timer.elapsedMs : timer.elapsedMs + (now - timer.startedAt);
}

export function timerRemaining(timer: TimerState, now: number): number {
  return Math.max(0, timer.durationMs - timerElapsed(timer, now));
}

export function startTimer(timer: TimerState, now: number): TimerState {
  return timer.startedAt === null ? { ...timer, startedAt: now } : timer;
}

export function pauseTimer(timer: TimerState, now: number): TimerState {
  return timer.startedAt === null
    ? timer
    : { ...timer, startedAt: null, elapsedMs: timerElapsed(timer, now) };
}

export function resetTimer(timer: TimerState): TimerState {
  return { ...timer, startedAt: null, elapsedMs: 0 };
}

export function isTimerFinished(timer: TimerState, now: number): boolean {
  return timer.mode === "countdown" && timerRemaining(timer, now) === 0;
}

export function formatDuration(ms: number): string {
  const total = Math.max(0, Math.floor(ms / 1000));
  const seconds = total % 60;
  const minutes = Math.floor(total / 60) % 60;
  const hours = Math.floor(total / 3600);
  const pad = (value: number) => String(value).padStart(2, "0");
  return hours > 0 ? `${pad(hours)}:${pad(minutes)}:${pad(seconds)}` : `${pad(minutes)}:${pad(seconds)}`;
}
